import { useNavigate } from 'react-router-dom';

import React from 'react'
import { ExitButton, StyledExitIcon } from '@/components/atoms/UI/ExitButton/styles';
import { ROUTES } from '@/constants/urls';


type Props = {
    children: React.ReactNode
}

const SmartCloseBackButton: React.FC<Props> = ({ children }) => {

    const navigate = useNavigate();

    const smartCloseBack = () => {
        const hostname = window.location.hostname;
        const currentURL = window.location.href;
        const updatedURL = new URL(currentURL);

        // Проверяем, является ли путь страницей с попыткой теста
        const isTestAttemptURL = updatedURL.pathname.match(/^\/a\/[^/]+\/?$/);

        if (import.meta.env.PROD) {
            // Если это тестовая страница
            if (isTestAttemptURL) {
                setTimeout(() => {
                    window.location.href = '/tests/';  // Редирект на /tests/
                }, 200);
            } else {
                window.history.back();  // Для всех остальных случаев — возврат по истории
            }
        } else {
            navigate('/');  // В случае дев-режима, переходим на главную
        }
    };


    return (
        <ExitButton onClick={smartCloseBack}>
            {children}
        </ExitButton>
    );
};

export default SmartCloseBackButton;